// hooks/useCustomPromo.ts
import { useEffect, useState } from "react";
import { useLocation } from "@gatsbyjs/reach-router";
import { isPresent } from "src/utils/checks";

type CustomPromoState = {
  showCustomPromoBanner: boolean;
  showCustomPromoModal: boolean;
  promoCode: string;
};

const STORAGE_KEY = "customPromoState";

export const useCustomPromo = () => {
  const [promoState, setPromoState] = useState<CustomPromoState>({
    showCustomPromoBanner: false,
    showCustomPromoModal: false,
    promoCode: ""
  });
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const promoCode = params.get("pc");

    if (isPresent(promoCode)) {
      localStorage.removeItem(STORAGE_KEY);

      const newState = {
        showCustomPromoBanner: true,
        showCustomPromoModal: true,
        promoCode: promoCode
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
      setPromoState(newState);
    } else {
      const savedState = localStorage.getItem(STORAGE_KEY);
      if (savedState) {
        setPromoState(JSON.parse(savedState));
      }
    }
  }, [location.search]);

  const updatePromoState = (updates: Partial<CustomPromoState>) => {
    const newState = { ...promoState, ...updates };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
    setPromoState(newState);
  };

  return {
    promoState,
    updatePromoState
  };
};
